const paymentEn = {
    "billing": {
        "name": "Name/Company name",
        "country": "Country",
        "postal_code": "Postal code",
        "city": "City",
        "address": "Address",
        "tax_number": "Tax number",
        "phone": "Phone number",
        "tax_number_helper_text": "Required for companies, not required for individuals",
        "billing_info": "Billing information",
        "emails_helper_text": "Optional. For multiple email addresses, separate them with commas",
    },
    "subscription_plans": {
        "PRO": "Pro plan",
        "FREE": "Free plan",
    },
    "plan_descriptions": {
        "PRO": "For restaurants looking to take their business to the next level! Translate your menu into new languages ​​with just a few clicks, ask your guests for feedback on their dishes, track your QR code menu usage with useful statistics, or let QuickPick AI automatically respond to your guests' feedback in your style!",
        "FREE": "For restaurants that want to get started with online menu and QR codes.",
    },
    "subscription_status": {
        "ACTIVE": "Active",
        "CANCELLED": "Cancelled",
    },
    "next_billing_date": "Next billing date",
    "current_subscription": "Current subscription",
    "cancel": "Cancel",
    "subscription_interval_prices": {
        "MONTHLY": "month",
        "YEARLY": "year",
        "HALF_YEARLY": "half year",
        "QUARTERLY": "quarter",
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Monthly subscription",
        "YEARLY": "Annual subscription",
        "HALF_YEARLY": "Half year subscription",
        "QUARTERLY": "Quarterly subscription",
    },
    "reactivate": "Reactivate",
    "valid_to": "Valid until",
    "payments_and_invoices": "Payments and invoices",
    "amount": "Amount",
    "invoice": "Invoice",
    "update_card": "Update",
    "payment_method": "Payment method",
    "cancel_subscription_confirmation": "Are you sure you want to cancel your current subscription?",
    "cancel_subscription_valid_until": "Until subscription will remain valid until the following date",
    "subscription_cancelled": "Subscription successfully canceled",
    "reactivate_confirmation": "Are you sure you want to reactivate the canceled subscription?",
    "reactivate_successful": "Subscription successfully reactivated",
    "change_payment_method": "Change payment method",
    "change_payment_method_tooltip": "To change your payment details, you must pay for the next subscription period. Of course, your subscription will be extended by the length of the period and the next billing date will be due by the same amount of time later.",
    "amount_to_be_paid": "Amount to be paid",
    "new_subscription_valid_until": "New subscription validity",
    "bank_card_expires_soon": "The bank card used for the subscription will expire soon.",
    "reactivate_subscription_confirmation": "Are you sure you want to reactivate the canceled subscription?",
    "billing_information": "Billing Information",
    "edit_billing_information": "Edit Billing Information",
    "no_available_invoices": "No invoices available",
    "subscribe": "Subscribe",
    "continue_to_payment": "Continue to payment",
    "confirm_subscription": "Confirm subscription",
    "subscription_page_title": "Start subscription",
    "pay": "Payment",
    "available_plans": "Available subscription",
    "accept_terms_and_conditions": "I have read and accept the <a>Terms and Conditions</a>",
    "accept_recurring_payments": "By paying, I accept the automatic charging of recurring payments, which I can cancel at any time.",
    "accept_privacy_policy": "I have read and accept the <a>Privacy Policy</a>",

    "subscribe_soon": "Coming soon",
}

export default paymentEn;